
<ng-container [formGroup]="scopeForm">
  <ng-container formArrayName="validScopes">
    <div class="grid " *ngFor="let scope of validScopesArray?.controls; let i = index">
      <ng-container [formGroupName]="i">
        <div class="col-12 lg:col-5 form-group flex flex-column gap-1">
          @if(loading){
          <app-skeleton [id]="'label-input-items'"></app-skeleton>
          } @else{
          <label for="scopeTYpe">Scope Type <span class="text-red-500">*</span></label>
          <p-select formControlName="scopeType" class="w-full" [options]="getScopeTypes(i)" id="scopeTYpe"
            placeholder="Scope type" />
          }
        </div>
        <div class="col-12 lg:col-5 form-group flex flex-column gap-1">
          @if(loading){
          <app-skeleton [id]="'label-input-items'"></app-skeleton>
          } @else{
          <label for="scopeName">Scope Name <span class="text-red-500">*</span></label>
          <p-multiSelect [options]="getScopeNamesForType(i)" id="scopeName" styleClass="w-full"
  placeholder="Select Scope" formControlName="scopeName" display="chip" [showClear]="true"
  (onClear)="updateTouchForScopeType(i)">
  <ng-template pTemplate="selectedItems" let-selectedItems>
    <div class="flex flex-wrap align-items-center gap-2" *ngIf="selectedItems?.length">
      <p-chip
        *ngFor="let item of selectedItems.slice(0, 3); let idx = index"
        [label]="item"
        [removable]="true"
        (onRemove)="$event.stopPropagation(); removeScopeName(i, idx, selectedItems)">
      </p-chip>
      <span *ngIf="selectedItems.length > 3" class="text-color-secondary text-sm">
        +{{ selectedItems.length - 3 }}
      </span>
    </div>
  </ng-template>
</p-multiSelect>
        <ng-container *ngIf="scopeForm?.get('validScopes')?.get(i.toString())?.get('scopeName') as scopeNameCtrl">
<ng-container *ngIf="scopeForm?.get('validScopes')?.get(i.toString())?.get('scopeType') as scopeTypeCtrl">
  <small class="flex gap-1 text-red-500 mt-1"
         *ngIf="(scopeNameCtrl?.touched && (!scopeNameCtrl?.value || scopeNameCtrl?.value?.length == 0)) ||
                (scopeTypeCtrl?.value == 'HIERARCHY' && scopeNameCtrl?.value?.length != 2)">
    <span class="flex gap-2 align-items-center"
          *ngIf="scopeNameCtrl?.touched && (!scopeNameCtrl?.value || scopeNameCtrl?.value?.length == 0)">
      <i class="ti ti-info-circle"></i>Scope Name is required
    </span>
    <span class="flex gap-2 align-items-center"
          *ngIf="scopeTypeCtrl?.value == 'HIERARCHY' && scopeNameCtrl?.value?.length != 2">
      <i class="ti ti-info-circle"></i>Choose Valid Hierarchy
    </span>
  </small>
</ng-container>
</ng-container>
          }
        </div>
        <div class="col-12 lg:col form-group">
          <label for="" class="hidden lg:block">&nbsp;</label>
          <div class="flex gap-2 buttons-icon justify-content-end">
            @if(loading){
            @for (i of [1,2]; track i) {
            <app-skeleton id="form-fields" [size]="{width:'2rem',height:'2rem'}"></app-skeleton>
            }
            }@else{
            <p-button [disabled]="generateType(validScopesArray,max)"
              *ngIf="i === validScopesArray.controls.length - 1" (onClick)="addNewScope()" icon="ti ti-plus">
               <i-tabler name="plus" class="ti-regular ti-lg"></i-tabler>
            </p-button>
            <p-button *ngIf="operation !== operationTypes.VIEW_ROLE" severity="danger" (onClick)="removeScope(i)" icon="ti ti-trash" >
               <i-tabler name="trash" class="ti-regular ti-lg"></i-tabler>
            </p-button>
            }
          </div>
        </div>
      </ng-container>
    </div>
    <div class="d-flex mt-1" *ngIf="validScopesArray.controls.length < 1">
      <p-button [disabled]="validScopesArray.length >= max" (onClick)="addNewScope()" icon="ti ti-plus"
        label="Add Scope" />
    </div>
  </ng-container>
</ng-container>